import React from "react";
import "../../styles/Layout/_Loader.scss";
import LoadingImg from "../../assets/Loading.gif";

const Loader = () => {
  return (
    <div className="loading">
      <span>
        <img src={LoadingImg} alt="loading img" className="circle-process" />
      </span>
      <h1>Loading...</h1>
    </div>
  );
};

export default Loader;



export const LoaderTable = () => {
  return (
    <div className="loading-table">
    <span>
      <img src={LoadingImg} alt="loading img" className="circle-process" />
    </span>
    <h1>Loading...</h1>
  </div>
  )
}

